const ArticleHelpers = {
    swr: {
        list: (company: string, type: string) => `/api/articles/${company}/${type}`,
        all: () => `/api/articles/`,
        get: (id: string) => `/api/articles/${id}`,
        search: (query: string | undefined) => `/api/articles/${query}`,
    },
};

export { ArticleHelpers };
